(function(root, undefined) {

	let lib = {};

	const updateTabCounter = lib.updateTabCounter = function() {

		$('.tab-pane').each(function() {
			const $tabPane = $(this);
			const tabPaneId = $tabPane.attr('id');
			const $tabNav = $('.nav-tabs .nav-item [aria-controls="' + tabPaneId + '"]').parent();
			if($tabNav.length === 0) return;
			const errorCount = $tabPane.find('.form-control.is-invalid').length;
			createTabValidationCount($tabNav, {'error': errorCount});
		});

	};

	const createTabValidationCount = lib.createTabValidationCount = function($tab, valcount) {

		if(!util.isEmpty(valcount)) {
			if (!util.isEmpty(valcount.error)) setTab($tab, 'danger', valcount.error);
			if (!util.isEmpty(valcount.warning)) setTab($tab, 'warning', valcount.warning);
			if (!util.isEmpty(valcount.info)) setTab($tab, 'success', valcount.info);
		}

		function setTab($tab, className, tabCount) {
			const $badge = $tab.find('.badge-' + className);

			if(tabCount === 0) {
				$badge.remove();
				return;
			}

			if($badge.length > 0) {
				$badge.html(tabCount);
			} else {
				$tab.find('a').append(
					' <span class="badge badge-pill badge-' + className + '">' + tabCount + '</span>'
				);
			}
		}
	};

	const clearErrors = lib.clearErrors = function() {
		const elemsIsInvalid = document.getElementsByClassName("is-invalid");
		while(elemsIsInvalid.length > 0) {
			const elem = elemsIsInvalid.item(0);
			elem.classList.remove('is-invalid');
			elem.setAttribute('aria-invalid', null);
		}

		const elemsCardAccentDanger = document.getElementsByClassName('card-accent-danger');
		while(elemsCardAccentDanger.length > 0) {
			const elem = elemsCardAccentDanger.item(0);
			elem.classList.remove('card-accent-danger');
		}

		document.querySelectorAll('em.error').forEach(e => e.parentNode.removeChild(e));

		const elemsIsValid = document.getElementsByClassName("is-valid");
		while(elemsIsValid.length > 0) {
			const elem = elemsIsValid.item(0);
			elem.classList.remove('is-valid');
			elem.setAttribute('aria-valid', null);
		}

		document.querySelectorAll('em.info').forEach(e => e.parentNode.removeChild(e));
		document.querySelectorAll('em.warning').forEach(e => e.parentNode.removeChild(e));
	};

	const updateUiErrors = lib.updateUiErrors = function (data) {
		if(data.sessionExpired) {
			window.location.href=util.getUrl("index", {'LOGIN_LOGOUT': '2'});
			return false;
		}
		clearErrors();
		setPageActionErrors(data.actionErrors);
		setPageActionMessages(data.actionMessages);
		setFieldErrors(data.fieldErrors);
		setFieldWarnings(data.fieldWarnings);
		setFieldInfos(data.fieldInfos);

		return true;
	};

	const hasMessages = lib.hasMessages = function(data) {
		return data.actionMessages && data.actionMessages.length > 0;
	}

	const hasErrors = lib.hasErrors = function(data) {
		if(Object.getOwnPropertyNames(data.fieldErrors).length > 0) return true;
		return data.actionErrors.length > 0;
	};

	const hasActionErrors = lib.hasActionErrors = function (data) {
		return data.actionErrors && data.actionErrors.length > 0;
	};

	const hasFieldErrors = lib.hasFieldErrors = function(data) {
		if(Object.getOwnPropertyNames(data.fieldErrors).length > 0) return true;
	};

	const getOutputContainer = lib.getOutputContainer = function() {

		//Aktiver Dialog
		let $mainContainer = document.querySelector('.modal.show .modal-body');
		if($mainContainer != null) return $mainContainer;

		//Wenn es eine contentbar gibt, dann in contentbar-content einfügen.
		$mainContainer = document.querySelector('#contentbarfixed-content');
		if($mainContainer != null) return $mainContainer;

		//Erster Container innerhalb des Hauptbereichs
		$mainContainer = document.querySelector('main.main .container-fluid');
		if($mainContainer != null) return $mainContainer;

		//Der erste verfügbare Container
		$mainContainer = document.querySelector('.container');
		if($mainContainer != null) return $mainContainer;

		//Einfach den Body
		return document.querySelector('body');

	};

	const setContainerActionErrors = lib.setContainerActionErrors = function (errors, mainContainer) {

		document.querySelectorAll('.action-errors').forEach(e => e.parentNode.removeChild(e));

		if(errors && errors.length > 0) {
			let html = '<div class="action-errors">';
			for(let i=0; i<errors.length; i++) {
				html += "<div class=\"alert alert-danger\" role=\"alert\">" + util.escapeHtml(errors[i]) + "</div>";
			}
			html += "</div>";

			if(mainContainer != null) {
				mainContainer.insertAdjacentHTML('afterbegin', html);
			}
		}
	};

	const setPageActionErrors = lib.setPageActionErrors = function (errors) {

		const mainContainer = getOutputContainer();
		setContainerActionErrors(errors, mainContainer);

		document.querySelectorAll('.action-errors').forEach(e => e.parentNode.removeChild(e));

		if(errors && errors.length > 0) {
			let html = '<div class="action-errors">';
			for(let i=0; i<errors.length; i++) {
				html += "<div class=\"alert alert-danger\" role=\"alert\">" + util.escapeHtml(errors[i]) + "</div>";
			}
			html += "</div>";

			if(mainContainer != null) {
				mainContainer.insertAdjacentHTML('afterbegin', html);
			}
		}
	};

	const setPageActionError = lib.setPageActionError = function(error) {
		setPageActionErrors([error]);
	};

	const setPageActionMessage = lib.setPageActionMessage = function(message) {
		setPageActionMessages([message]);
	};

	const setPageActionMessages = lib.setPageActionMessages = function (messages) {

		const mainContainer = getOutputContainer();

		document.querySelectorAll('.action-messages').forEach(e => e.parentNode.removeChild(e));

		if(messages && messages.length > 0) {
			let html = '<div class="action-messages">';
			for(let i=0; i<messages.length; i++) {
				html += "<div class=\"alert alert-info\" role=\"alert\">" + util.escapeHtml(messages[i]) + "</div>";
			}
			html += "</div>";

			if(mainContainer != null) {
				mainContainer.insertAdjacentHTML('afterbegin', html);
			}
		}
	};

	const createPoppers = lib.createPoppers = function() {
		$('table:not(.no-popup-feedback) .invalid-feedback, .popup-feedback .invalid-feedback').each( function() {
			const $arrow = $('<div class="popper__arrow" x-arrow="">');
			const $errorElem = $(this).addClass('invalid-feedback-popup').removeClass('invalid-feedback').append($arrow);
			$errorElem.closest('.has-error, .controls, .form-group').find('[name]').data("popper", $errorElem);
		});
	};

	const createInfoPoppers = lib.createInfoPoppers = function() {
		$('table:not(.no-popup-feedback) .valid-feedback, .popup-feedback .valid-feedback').each( function() {
			const $arrow = $('<div class="popper__arrow" x-arrow="">');
			const $errorElem = $(this).addClass('valid-feedback-popup').removeClass('valid-feedback').append($arrow);
			$errorElem.closest('.has-error, .controls, .form-group').find('[name]').data("popper", $errorElem);
		});
	};

	const setFieldErrors = lib.setFieldErrors = function(fieldErrors) {

		for (const field in fieldErrors) {
			if(fieldErrors.hasOwnProperty(field)) {
				createFieldError(field, fieldErrors[field]);
			}
		}

		createPoppers();

		//$('.invalid-feedback').attr('style', 'display:inline');
		const elemsInvalidFeedback = document.getElementsByClassName('invalid-feedback');
		for (let i = 0; i < elemsInvalidFeedback.length; i++) {
			elemsInvalidFeedback[i].setAttribute("style", 'display:inline');
		}

		//$('.card:has(.is-invalid)').addClass('card-accent-danger');
		const elemsCards = document.getElementsByClassName('card');
		for (let i = 0; i < elemsCards.length; i++) {
			const elemCard = elemsCards[i];
			if(elemCard.getElementsByClassName('is-invalid').length > 0) {
				elemCard.classList.add('card-accent-danger');
			}
		}

	};

	const htmlToElement = lib.htmlToElement = function(html) {
		const template = document.createElement('template');
		template.innerHTML = html.trim();
		return template.content.firstChild;
	};

	const createFieldError = lib.createFieldError = function(fieldName, messages) {
		let field = document.querySelector('[name="advcombo-text-' + fieldName + '"]');
		if(field != null) {
			field = field.parentNode;
		} else {
			field = document.querySelector('[name="' + fieldName + '"],[data-name="' + fieldName + '"]');
		}

		if(field == null) return;

		field.classList.add('is-invalid');
		field.setAttribute('aria-invalid', 'true');

		const createPopper = field.closest('table:not(.no-popup-feedback), .popup-feedback') != null;
		const noFeedback = field.closest('.no-feedback') != null;

		if (noFeedback) {
			return;
		}

		const styleHtml = !createPopper ? ' style="display:inline"' : '';

		let errorElemHtml = "";
		for (let i = 0; i < messages.length; ++i) {
			errorElemHtml += '<em class="error invalid-feedback"' + styleHtml + '>' + util.escapeHtml(messages[i]) + '</em>';
		}

		const $inputGroup = field.closest('.input-group');
		if($inputGroup != null) {
			$inputGroup.insertAdjacentHTML('beforeend', errorElemHtml);
		} else {
			field.parentNode.insertBefore(htmlToElement(errorElemHtml), field.nextSibling);
		}
	};

	const setFieldInfos = lib.setFieldInfos = function(fieldInfos) {
		for (let field in fieldInfos) {
			if(fieldInfos.hasOwnProperty(field)) {
				createFieldValid(field, fieldInfos[field], 'info');
			}
		}

		createInfoPoppers();

		//$('.valid-feedback').attr('style', 'display:inline');
		const elemsValidFeedback = document.getElementsByClassName('valid-feedback');
		for (let i = 0; i < elemsValidFeedback.length; i++) {
			elemsValidFeedback[i].setAttribute("style", 'display:inline');
		}

	};

	const setFieldWarnings = lib.setFieldWarnings = function(fieldInfos) {
		for (let field in fieldInfos) {
			if(fieldInfos.hasOwnProperty(field)) {
				createFieldValid(field, fieldInfos[field], 'warning');
			}
		}

		createInfoPoppers();

		//$('.valid-feedback').attr('style', 'display:inline');
		const elemsValidFeedback = document.getElementsByClassName('valid-feedback');
		for (let i = 0; i < elemsValidFeedback.length; i++) {
			elemsValidFeedback[i].setAttribute("style", 'display:inline');
		}

	};

	const createFieldValid = lib.createFieldInfo = function(fieldName, messages, className) {
		let field = document.querySelector('[name="advcombo-text-' + fieldName + '"]');
		if(field != null) {
			field = field.parentNode;
		} else {
			field = document.querySelector('[name="' + fieldName + '"],[data-name="' + fieldName + '"]');
		}

		if(field == null) return;

		field.classList.add('is-valid');
		field.classList.add(className);
		field.setAttribute('aria-valid', 'true');

		const createPopper = field.closest('table:not(.no-popup-feedback), .popup-feedback') != null;
		const noFeedback = field.closest('.no-feedback') != null;

		if (noFeedback) {
			return;
		}

		const styleHtml = !createPopper ? ' style="display:inline"' : '';

		let infoHtml = "";
		for (let i = 0; i < messages.length; ++i) {
			infoHtml += '<em class="'+ className + ' valid-feedback"' + styleHtml + '>' + util.escapeHtml(messages[i]) + '</em>';
		}

		const $inputGroup = field.closest('.input-group');
		if($inputGroup != null) {
			$inputGroup.insertAdjacentHTML('beforeend', infoHtml);
		} else {
			field.parentNode.insertBefore(htmlToElement(infoHtml), field.nextSibling);
		}
	};

	root['validationaware'] = lib;

// Root will be `window` in browser or `global` on the server:
}(window));